import { Box, styled } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
const doNotForward = /* @__PURE__ */ new Set(["ownerState", "columns"]);
const GridLayout = styled(Box, {
  name: colorPickerName,
  slot: "GridLayout",
  shouldForwardProp: (prop) => !doNotForward.has(prop)
})(({ columns }) => ({
  display: "inline-grid",
  gridTemplateColumns: `repeat(${columns}, 1fr)`,
  overflowY: "auto",
  width: "fit-content"
}));
export {
  GridLayout
};
//# sourceMappingURL=GridLayout.js.map
